import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Card extends Component {
    constructor(props) {
        super(props);
        this.goToLink = this.goToLink.bind(this);
    }
    
    goToLink() {
        this.props.history.push('/location?id=' + this.props.link);
    }
    
    render() {

        let price = null;
        if (this.props.price != "") {
            price = <p className="card__text">{this.props.price}</p>
        }

        return (
            <div className="card">
                <div className="card__content">
                    <p className="card__title">
                        {this.props.title}
                    </p>
                    {/* distance */}
                    {price}
                </div>
                <div className="card__actions">
                    <a className="card__action" onClick={this.goToLink}>See info</a>
                </div>
            </div>
        )
    }
}

export default Card;;


// WEBPACK FOOTER //
// ./src/components/elements/Card.js